import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// This is for revalidating form on language change. The invalid form text are read
// from the form text content, therefore re-validation is required to update those texts
// in chosen language
export const useValidationOnLanguageChange = (
  formRef: React.RefObject<HTMLFormElement | null>,
  validateForm: (form: HTMLFormElement) => void,
  validated: boolean,
) => {
  const isFirstRender = useRef(true);
  const prevLangRef = useRef<string | undefined>(undefined);
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (
      prevLangRef.current !== language &&
      formRef.current &&
      validated
    ) {
      validateForm(formRef.current);
    }

    prevLangRef.current = language;
  }, [language, validateForm, formRef, validated]);
};
